import { MapboxOverlay, MapboxOverlayProps } from '@deck.gl/mapbox/typed';
import { FC, useEffect } from 'react';
import { useControl } from 'react-map-gl';

const DeckGLOverlay: FC<
  MapboxOverlayProps & {
    interleaved?: boolean;
  }
> = props => {
  // @ts-expect-error - MapboxOverlay types are incompatible with react-map-gl's IControl but work at runtime
  const overlay = useControl<MapboxOverlay>(() => new MapboxOverlay(props));
  overlay.setProps(props);

  // Clean up overlay if map is removed
  // useControl returns the overlay instance, and cleans up on unmount,
  // but we ensure overlay is removed from the map if the map is gone.
  // react-map-gl calls cleanup when the parent map unmounts.
  // No additional code is needed unless you want to be explicit:
  // Remove overlay from map on unmount
  useEffect(() => {
    return () => {
      overlay.finalize();
    };
  }, [overlay]);

  return null;
};

export default DeckGLOverlay;
